import { DateTime } from "luxon";

import { DateUtils } from "@/utils/dateUtils";

export const TandemConstants = {
  CGM_STATUS: {
    // TODO Test CGM Calibration
    CGM_NORMAL: { value: 0, name: "Glucose Value" },
    CGM_HI: { value: 1, name: "HI glucose reading" },
    CGM_LO: { value: 2, name: "LO glucose reading" },
    CGM_CALIBRATION: {
      value: 3,
      name: "Glucose Value in response to calibration",
    },
    CGM_HI_CALIBRATION: {
      value: 4,
      name: "HI glucose reading in response to calibration",
    },
    CGM_LO_CALIBRATION: {
      value: 5,
      name: "LO glucose reading in response to calibration",
    },
    CGM_DO_NOT_SHOW: { value: 6, name: "Do not store" },
  },
  CGM_GX_TYPE: {
    NOT_SET: { value: 0, name: "EGV type not set" },
    FMR: { value: 1, name: "Five Minute Reading (FMR)" },
    CALIBRATION: { value: 2, name: "Calibration" },
    BACKFILL: { value: 3, name: "Backfill" },
  },
  CGM_GXB_TYPE: {
    FMR: { value: 1, name: "Five Minute Reading (FMR)" },
    BACKFILL: { value: 2, name: "Backfill" },
    IMV: { value: 4, name: "Immediate Match Value" },
    CALIBRATION: { value: 8, name: "Calibration" },
    NONE: { value: 16, name: "None" },
  },
  BG_READING_SOURCE: {
    MANUAL_ENTRY: { value: 0, name: "Manual entry by the user" },
    AUTO_POPULATED: { value: 1, name: "Auto populated BG using CGM" },
  },
  COMMANDED_RATE_SOURCE: {
    SUSPENDED: { value: 0, name: "Suspended" },
    PROFILE: { value: 1, name: "Profile" },
    TEMP: { value: 2, name: "Temp Rate" },
    ALGORITHM: { value: 3, name: "Algorithm" },
    TEMP_AND_ALGORITHM: { value: 4, name: "Temp Rate and Algorithm" },
  },
  PUMP_CONTROL_MODE: {
    NO_CONTROL: { value: 0, name: "No control" },
    OPEN_LOOP: { value: 1, name: "Open loop" },
    PINING: { value: 2, name: "Pining" },
    CLOSED_LOOP: { value: 3, name: "Closed loop" },
  },
  USER_MODE: {
    NORMAL: { value: 0, name: "normal" },
    SLEEPING: { value: 1, name: "sleep" },
    EXERCISING: { value: 2, name: "physicalActivity" },
    RESERVED: { value: 3, name: "reserved" },
  },
  BOLUS_TYPE: {
    INSULIN: { value: 0, name: "Insulin" },
    CARB: { value: 1, name: "Carb" },
    AUTOMATIC_CORRECTION: { value: 2, name: "Automatic correction" },
    REMOTE: { value: 3, name: "Remote" },
  } as const,
  SOURCE_TYPE: {
    LOCAL: { value: 0, name: "Local pump entry" },
    REMOTE: { value: 1, name: "Remote entry" },
  },
  BASE_TIME: DateTime.fromObject({ year: 2008, month: 1, day: 1 }, { zone: "utc" })
    .minus({ minutes: DateUtils.tzOffset(DateTime.now()) })
    .toSeconds(),
  SIGNIFICANT_DIGITS: 5,
  INTERVAL_FREQ: 10,
  SEND_WAIT: 800,
  RETRY_TIMEOUT: 1000,
  MAX_TRIES: 5,
  SYNC_BYTE: 0x55,
  VENDOR_ID: 1155,
  PRODUCT_ID: 22336,
  BITRATE: 921600,
  SEND_TIMEOUT: 50,
  RECEIVE_TIMEOUT: 50,
  MAX_RECORDS_PER_REQUEST: 1000,
  API_DEVICE_NAME_OPEN: "tandem slim x2",
  API_DEVICE_NAME_CLOSED: "tandem slim x2 control iq",
  CGM_DEVICE_NAME: "tandem cgm",
  API_DEVICE_MANUFACTURER: "tandem",
  OPEN_LOOP_DISPLAY_NAME: "T:SLIM X2",
  CLOSED_LOOP_DISPLAY_NAME: "T:SLIM X2 Control-IQ",
  CGM_DISPLAY_NAME: "T:SLIM X2 CGM",
  MAX_TOTAL_RECORDS: 100_000,
};
